import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH, ONBOARDING_PATH } from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { user, hasOnboarded, isReady } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.onboarding_status) {
            navigate(hasOnboarded ? DASHBOARD_PATH : ONBOARDING_PATH, { replace: true });
        }
    }, [user, hasOnboarded, navigate, isReady]);

    return children;
};

export default GuestGuard;
